
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class IcStockAdjustOutDialog extends Serenity.EntityDialog<IcStockAdjustOutRow, any> {
        protected getFormKey() { return IcStockAdjustOutForm.formKey; }
        protected getIdProperty() { return IcStockAdjustOutRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockAdjustOutRow.localTextPrefix; }
        protected getNameProperty() { return IcStockAdjustOutRow.nameProperty; }
        protected getService() { return IcStockAdjustOutService.baseUrl; }
        protected getDeletePermission() { return IcStockAdjustOutRow.deletePermission; }
        protected getInsertPermission() { return IcStockAdjustOutRow.insertPermission; }
        protected getUpdatePermission() { return IcStockAdjustOutRow.updatePermission; }

        protected form = new IcStockAdjustOutForm(this.idPrefix);
        constructor() {
            super();

            
            (this.form.AdjustOutDtList.view as any).onDataChanged.subscribe(() => {
                // let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                var Check = this.form.AdjustOutDtList.getItems().length;
                console.log("Checkups : " + Check);
                // self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
                this.calcDataOnGrid();

            });

            this.form = new IcStockAdjustOutForm(this.idPrefix);

            this.form.PostFg.element.parent();
            (this.form.AdjustOutDtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
            });

            this.form.StkAdjCode.changeSelect2(async e => {
                var stkcode = this.form.StkAdjCode.value
                // if (stkcode == '19') {
                //     this.applyChangesButton.toggleClass('disabled', true);
                //     Q.warning("ไม่สามารถสร้างเอกสาร ตรวจนับจากรายการนี้ได้ โปรดเข้าเมนูตรวจนับ ระบบจะทำการสร้างเอกสารปรับปรุงลด ให้อัตโนมัติเมื่ออนุมัติการตรวจนับแล้ว")
                //     this.form.StkAdjCode.value = '15'
                // }
                if (stkcode == '13' || stkcode == '16') {
                    this.applyChangesButton.toggleClass('disabled', true);
                    Q.warning("ไม่สามารถสร้างเอกสาร ประกอบ/แยกจากรายการนี้ได้ โปรดเข้าเมนูประกอบ/แยก ระบบจะทำการสร้างเอกสารปรับปรุงลด ให้อัตโนมัติเมื่ออนุมัติแล้ว")
                    this.form.StkAdjCode.value = '15'
                }
            });

            this.form.AdjFg.changeSelect2(async e => {
                var adjfg = this.form.AdjFg.value;
                this.form.AdjustOutDtList.AdjFg = Number(adjfg);
            });

        }
        protected initToolbar() {
            super.initToolbar();

        }

        private calcDataOnGrid() {
              (this.form.AdjustOutDtList.view as any).onDataChanged.subscribe(() => {
               
               var Check = this.form.AdjustOutDtList.getItems().length;
               console.log("Checkup : " + Check);
               if(Check == 0 || Check == null){
                Serenity.EditorUtils.setReadOnly(this.form.AdjFg, false);                
               }else{
                Serenity.EditorUtils.setReadOnly(this.form.AdjFg,true );               
               }
            });

            (this.form.AdjustOutDtList.view as any).onRowCountChanged.subscribe(() => {
               
                var Check = this.form.AdjustOutDtList.getItems().length;
                console.log("Checkup : " + Check);
                if(Check == 0 || Check == null){
                 Serenity.EditorUtils.setReadOnly(this.form.AdjFg, false);                
                }else{
                 Serenity.EditorUtils.setReadOnly(this.form.AdjFg,true );               
                }

            });
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSavePosBtn: Serenity.ToolButton =
                {
                    title: "POST",
                    hint: "Post and Save",
                    separator: false,
                    cssClass: "button-save-post",
                    icon: "fa fa-save",
                    hotkey: 'alt+shift+s',
                    onClick: (e) => {
                        var self = this;
                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    var a = this.loadById(id1);
                                }
                                else {
                                    var a = this.loadById(response.EntityId);
                                }

                                // this.showSaveSuccessMessage(response);
                                Q.confirm('ยืนยันการบันทึกเอกสาร POST', () => {
                                    this.form.PostFg.value = "3";
                                    this.form.PostFg.forceUpdate();
                                    this.save((response1) => {
                                        this.dialogClose();
                                    });
                                });

                            });

                            options.onError = function (response) {
                                Q.alert(response.Error.Message);

                            }

                            Q.serviceCall(options);
                        }




                    }
                };
                buttons.push(newSavePosBtn);
                let newSaveBtn: Serenity.ToolButton =
                {
                    title: "บันทึกเอกสาร แต่ยังไม่ POST",
                    hint: "Save",
                    separator: false,
                    cssClass: "button-save",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        var self = this;


                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    this.loadById(id1);
                                }
                                else {
                                    // this.loadById(response.EntityId);
                                    this.dialogClose();
                                }

                                this.showSaveSuccessMessage(response);


                            });

                            options.onError = function (response) {
                                if (response.Error.Message == "Can't save record. There is another record with the same เลขที่เอกสาร value!") {
                                    Q.alert(response.Error.Message = "เลขที่เอกสารถูกใช้งานแล้ว ระบบจำทำการบรับเลขที่เอกสาร โปรดทำการบันทึกอีกครั้ง");
                                    var s = self.form.SysDocNo.value
                                    var f = s.substring(0, 9)
                                    GeniuzPOS.Inventory.IcStockAdjustOutService.GetNextNumber({
                                        Prefix: f,
                                        Length: 15
                                    }, response => {

                                        self.form.SysDocNo.value = response.Serial;

                                    });
                                } else { Q.alert(response.Error.Message); }



                            }

                            Q.serviceCall(options);
                        } else {
                            this.save((response) => {
                                this.dialogClose();
                            });


                        }

                    }
                };
                buttons.push(newSaveBtn);
                let newDeleteBtn: Serenity.ToolButton =
                {
                    title: "ลบเอกสาร'",
                    hint: "Delete",
                    separator: false,
                    cssClass: "delete-button",
                    icon: "fa fa-save",
                    hotkey: 'alt+x',
                    onClick: (e) => {
                        Q.confirm('ยืนยันการลบเอกสาร', () => {
                            this.form.CancelFg.value = "2";
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                    }
                };
                buttons.push(newDeleteBtn);


            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );

            return buttons;
        }
    
        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.AdjustOutDtList.myPassValue = this.entity.SysDocNo

            if (this.entity.PostFg == 1) {
                this.form.AdjustOutDtList.myPassValue2 = this.entity.PostFg;
            } else {
                this.form.AdjustOutDtList.myPassValue2 = 0;
            }
            if (this.isNew()) {
                this.getNextNumber();
                this.toolbar.findButton('button-save-post').hide();
                this.toolbar.findButton('delete-button').hide();
                this.form.AdjustOutDtList.AdjFg = 0;
            }else{
                this.form.AdjustOutDtList.AdjFg = Number(this.entity.AdjFg);
            }
            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                            self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();
            if (this.entity.PostFg == 1 || this.entity.PostFg == 2 || this.entity.CancelFg == 1) {
                this.toolbar.findButton('creates-followup-button').hide();
                this.toolbar.findButton('genarate-po-button').hide();
                this.toolbar.findButton('button-save-post').hide();
                this.toolbar.findButton('button-save').hide();
                this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);
                //Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                // this.applyChangesButton.toggleClass('disabled', true);
                // this.saveAndCloseButton.toggleClass('disabled', true);
                this.deleteButton.toggleClass('disabled', true);
                this.form.AdjustOutDtList.set_readOnly(true);
                Serenity.EditorUtils.setReadonly(this.form.DocNo.element, true);
                Serenity.EditorUtils.setReadonly(this.form.DocDate.element, true);
                Serenity.EditorUtils.setReadonly(this.form.RefDocNo1.element, true);
                Serenity.EditorUtils.setReadonly(this.form.RefDocNo2.element, true);
                Serenity.EditorUtils.setReadonly(this.form.WhsId.element, true);
                Serenity.EditorUtils.setReadonly(this.form.StockTo.element, true);
                Serenity.EditorUtils.setReadonly(this.form.Remark.element, true);
                Serenity.EditorUtils.setReadonly(this.form.StkAdjCode.element, true);
            } else {
                this.toolbar.findButton('apply-changes-button').hide();

            }

        }

        protected getSaveEntity(): IcStockAdjustOutRow {
            let entity = super.getSaveEntity();
            return entity;
        }


        private getNextNumber() {
            var val = Q.trimToNull(this.form.SysDocNo.value);



            if (!val || val.length <= 3) {
                var someDate = new Date();
                var dd = someDate.getDate();
                var mm = someDate.getMonth() + 1;
                var myRow = 0;
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                console.log('User Id : ' + userId.ShopId);
                try {
                    var userRole = Q.first(Administration.UserRoleRow.getLookup().items, x => x.UserId == userId.UserId);

                    if (userRole != null) {
                        myRow = userRole.RoleId;
                    }
                    if (userRole != null || userRole.RoleId.valueOf) {
                        myRow = userRole.RoleId;
                    }
                    if (myRow == 1) {
                        //(this.form.SlmnCode.element as any).select2(userId.SlmnCode);
                    }
                } catch {

                }

                var y = someDate.getFullYear();
                var mo = "";
                var ddd = "";

                if (mm < 10) {
                    mo = '0' + mm;

                } else {
                    mo = mm.toString();
                }

                if (dd < 10) {
                    //ddd = '0' + dd;
                    ddd = '';

                } else {
                    //ddd = dd.toString();
                    ddd = '';
                }

                var someFormattedDate = y.toString().substr(2, 2);

                var docprefix = Q.tryFirst(Product.CsDocTypeRow.getLookup().items, x => x.DocType == "36").DocPrefix;
                var prefix = docprefix + userId.ShopId + someFormattedDate + mo + ddd;
                GeniuzPOS.Inventory.IcStockAdjustOutService.GetNextNumber({
                    Prefix: prefix,
                    Length: 15
                }, response => {

                    this.form.SysDocNo.value = response.Serial;
                    this.form.DocDate.element.focus();
                });
            }

        }


    }
}